import React from 'react';
import { Edit, TabbedForm, FormTab, TextInput, useRecordContext, BooleanInput, NumberInput} from 'react-admin';
// import VideoReorderList from '../admin/videoReorderList';
import ImageSelectorField from './imageSelectorField';


const CourseEdit = () => {
  return (
    <Edit>
      <TabbedForm>
        <FormTab label="Detalles">
          <TextInput source="title" fullWidth />
          <TextInput source="description" fullWidth />
          <TextInput source="level" />
          <TextInput source="status" />
          <BooleanInput source="isActive" />
          <NumberInput source="price" fullWidth />

          <ImageSelectorField />
          <TextInput source="image" style={{ display: 'none' }} />
        </FormTab>

        <FormTab label="Videos">
          <CourseVideoTab />
        </FormTab>
      </TabbedForm>
    </Edit>
  );
};

// Extraemos el contenido del tab "Videos" en un componente separado
const CourseVideoTab = () => {
  const record = useRecordContext(); // Aquí sí se puede usar correctamente

  if (!record) return null;

  return <p>La funcionalidad de reordenar videos ha sido desactivada temporalmente.</p>;
  // return <VideoReorderList courseId={record.id} />;
};

export default CourseEdit;

